// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Supplychainmanagamentcompanyinpune() {



const cardData = {


    keyword: "Supply Chain Management Company in Pune",

    headingDescription: "SSK Logistic supports businesses searching for a Supply Chain Management Company in Pune with coordinated logistics solutions designed to connect procurement, transportation, warehousing, distribution, inventory movement, and final delivery requirements. Supply chain operations often involve multiple suppliers, warehouses, manufacturing facilities, distributors, and customer locations, making dependable coordination essential for maintaining smooth material flow. SSK Logistic focuses on practical supply chain planning and transportation support for industrial, commercial, manufacturing, and distribution requirements. From organized goods movement and warehouse coordination to route planning, distribution support, and third-party logistics assistance, the service approach is structured around improving visibility, reducing unnecessary movement, and maintaining consistent delivery schedules across Pune and major business destinations.",

    topPlaces: [
        {
            title: "Daund",
            description: "Daund serves as an important commercial and transportation location in the Pune region, making it relevant for businesses coordinating raw materials, finished goods, and distribution movements. SSK Logistic can support supply chain transportation requirements connecting businesses in and around Daund with manufacturing units, warehouses, suppliers, and destination markets."
        },
        {
            title: "Pune to Delhi",
            description: "The Pune to Delhi corridor is useful for companies managing long-distance movement of industrial goods, commercial consignments, and finished products. SSK Logistic supports organized transportation planning for businesses requiring dependable freight movement between Pune operations and major northern markets."
        },
        {
            title: "Kurkumbh",
            description: "Kurkumbh is associated with industrial and manufacturing activity where coordinated movement of materials and finished products can be an important part of supply chain planning. SSK Logistic assists businesses with transportation coordination, distribution movement, and logistics support connected with Kurkumbh-based operations."
        },
        {
            title: "Pune to Kolkata",
            description: "Pune to Kolkata transportation can support supply chains that extend from western India toward eastern commercial markets. SSK Logistic helps businesses coordinate long-distance freight movement with suitable planning for industrial materials, commercial consignments, and regular distribution requirements."
        },
        {
            title: "Sanaswadi",
            description: "Sanaswadi provides access to the eastern side of Pune's broader industrial and commercial network. Businesses operating in this belt can use structured logistics support for supplier movements, manufacturing requirements, warehouse transfers, and distribution activities managed through SSK Logistic."
        },
        {
            title: "Pune to Lucknow",
            description: "The Pune to Lucknow route is relevant for businesses distributing products and industrial goods into northern markets. SSK Logistic provides transportation coordination that can help connect Pune-based supply chain operations with warehouses, distributors, commercial destinations, and customer networks around Lucknow."
        },
        {
            title: "Katraj",
            description: "Katraj connects Pune with several important residential, commercial, and highway-linked areas, creating regular requirements for goods movement and distribution coordination. SSK Logistic supports businesses with transportation and supply chain services for planned local and regional movement."
        },
        {
            title: "Pune to Jodhpur",
            description: "Pune to Jodhpur is a useful long-distance corridor for businesses serving western and northern Indian markets. SSK Logistic can coordinate freight transportation for commercial and industrial consignments while helping businesses maintain continuity between Pune-based operations and destination-side distribution."
        },
        {
            title: "Narhe",
            description: "Narhe is part of Pune's growing commercial and industrial surroundings, where businesses may require regular movement between suppliers, facilities, warehouses, and customers. SSK Logistic provides supply chain transportation support designed around scheduled and recurring goods movement requirements."
        },
        {
            title: "Pune to Noida",
            description: "Pune to Noida connects western India's business network with a major commercial and industrial market in the National Capital Region. SSK Logistic supports businesses requiring planned freight transportation, distribution coordination, and supply chain movement between Pune facilities and Noida-area destinations."
        }
    ],

    "services": [
        {
            "name": "supply chain management company pune",
            "description": "Businesses looking for a supply chain management company pune can use SSK Logistic for coordinated transportation, distribution, warehousing support, and goods movement planning. The service approach connects different stages of the supply chain so industrial and commercial consignments can move in a more organized manner."
        },
        {
            "name": "supply chain management services pune",
            "description": "SSK Logistic provides supply chain management services pune for businesses requiring structured coordination across transportation, distribution, warehouse transfers, and recurring goods movement. Solutions can be aligned with operational schedules, destination requirements, and the movement patterns of different types of businesses."
        },
        {
            "name": "supply chain company pune",
            "description": "A supply chain company pune can help businesses coordinate the movement of materials from suppliers through operational facilities and onward to distribution points. SSK Logistic supports these requirements with transportation planning and logistics coordination suited to industrial and commercial supply chains."
        },
        {
            "name": "supply chain solutions pune",
            "description": "SSK Logistic develops practical supply chain solutions pune for businesses that need better coordination between transportation, distribution, warehousing, and delivery activities. The focus is on creating organized movement plans that can support recurring logistics requirements and changing shipment schedules."
        },
        {
            "name": "supply chain logistics pune",
            "description": "Supply chain logistics pune requirements often involve multiple transportation stages and destination points. SSK Logistic assists businesses with coordinated freight movement, warehouse transfers, distribution support, and route planning to maintain a smoother flow of goods throughout their operational network."
        },
        {
            "name": "supply chain service provider pune",
            "description": "As a supply chain service provider pune, SSK Logistic supports businesses that need dependable coordination for transportation and distribution activities. Services can be structured around recurring consignments, warehouse movement, supplier requirements, and delivery schedules across Pune and connected markets."
        },
        {
            "name": "supply chain management services in pune",
            "description": "Supply chain management services in pune can cover several connected logistics activities, from transportation coordination to warehouse and distribution movement. SSK Logistic provides organized support that helps businesses manage goods flow between suppliers, facilities, storage locations, distributors, and destination markets."
        },
        {
            "name": "logistics and supply chain company pune",
            "description": "SSK Logistic supports businesses searching for a logistics and supply chain company pune with integrated transportation and distribution coordination. The approach combines freight movement, warehouse transfers, route planning, and delivery support to address different stages of commercial and industrial supply chains."
        },
        {
            "name": "supply chain consulting company pune",
            "description": "Businesses researching a supply chain consulting company pune may require practical guidance around transportation coordination, distribution planning, warehouse movement, and logistics processes. SSK Logistic can support these operational requirements with experience-focused planning for structured goods movement."
        },
        {
            "name": "end to end supply chain pune",
            "description": "End to end supply chain pune requirements involve coordinating multiple stages from material movement and transportation through warehousing, distribution, and delivery. SSK Logistic supports businesses with connected logistics activities designed to simplify coordination across different points in the supply chain."
        },
        {
            "name": "supply chain transportation pune",
            "description": "Supply chain transportation pune services are important for maintaining continuous movement between suppliers, manufacturing facilities, warehouses, distributors, and customers. SSK Logistic coordinates transportation requirements according to route, cargo type, destination, and recurring operational schedules."
        },
        {
            "name": "supply chain distribution services pune",
            "description": "SSK Logistic offers supply chain distribution services pune for businesses managing deliveries across multiple locations and market areas. Distribution support can include planned transportation, warehouse-to-destination movement, recurring dispatch coordination, and organized delivery scheduling."
        },
        {
            "name": "supply chain warehouse services pune",
            "description": "Supply chain warehouse services pune support businesses that need coordinated movement between storage facilities and other points in their logistics network. SSK Logistic assists with warehouse-related transportation, stock movement, transfer requirements, and distribution coordination for commercial operations."
        },
        {
            "name": "supply chain logistics provider pune",
            "description": "A supply chain logistics provider pune can help businesses coordinate transportation and distribution activities across several operational stages. SSK Logistic provides logistics support for industrial and commercial goods movement, helping connect suppliers, warehouses, facilities, distributors, and delivery destinations."
        },
        {
            "name": "supply chain solutions provider pune",
            "description": "SSK Logistic works as a supply chain solutions provider pune for businesses requiring organized transportation, distribution, warehouse movement, and logistics coordination. Solutions can be adapted to recurring supply chain requirements, shipment volumes, routes, and destination networks."
        },
        {
            "name": "industrial supply chain management pune",
            "description": "Industrial supply chain management pune requires careful coordination of raw materials, components, machinery, finished goods, and supporting logistics activities. SSK Logistic assists industrial businesses with transportation and distribution planning that connects production facilities with suppliers, warehouses, and markets."
        },
        {
            "name": "commercial supply chain services pune",
            "description": "Commercial supply chain services pune help businesses manage regular product movement between suppliers, storage locations, distribution centers, and customers. SSK Logistic provides transportation and logistics coordination for commercial operations requiring dependable scheduling and organized freight movement."
        },
        {
            "name": "supply chain operations pune",
            "description": "Supply chain operations pune involve the continuous coordination of transportation, storage, distribution, and goods movement activities. SSK Logistic supports operational requirements through structured freight planning, route coordination, warehouse transfers, and distribution assistance for businesses."
        },
        {
            "name": "supply chain optimization pune",
            "description": "Supply chain optimization pune focuses on improving how goods move through transportation, warehousing, and distribution stages. SSK Logistic supports businesses by organizing practical logistics workflows, coordinating routes, and reducing unnecessary movement between connected supply chain points."
        },
        {
            "name": "supply chain partner pune",
            "description": "Businesses seeking a supply chain partner pune can work with SSK Logistic for transportation, distribution, and logistics coordination across recurring operational requirements. The service model is designed to support businesses that need consistent movement between multiple suppliers, facilities, warehouses, and destination markets."
        },
        {
            "name": "reliable supply chain company pune",
            "description": "A reliable supply chain company pune is important for businesses managing regular movement of industrial and commercial goods. SSK Logistic focuses on organized transportation coordination, clear movement planning, and structured distribution support to help maintain continuity across different logistics stages."
        },
        {
            "name": "professional supply chain management pune",
            "description": "Professional supply chain management pune requires coordination between transportation, warehouse operations, distribution activities, and delivery schedules. SSK Logistic provides structured logistics support for businesses seeking a practical approach to managing recurring and multi-location goods movement."
        },
        {
            "name": "supply chain transportation services pune",
            "description": "Supply chain transportation services pune are designed for businesses that need goods moved efficiently between suppliers, manufacturing units, warehouses, distribution points, and customers. SSK Logistic coordinates route-based transportation requirements according to operational priorities and shipment needs."
        },
        {
            "name": "supply chain distribution company pune",
            "description": "A supply chain distribution company pune supports businesses with the movement of products from storage and operational facilities toward distributors and destination markets. SSK Logistic assists with distribution transportation, recurring dispatches, warehouse transfers, and organized delivery coordination."
        },
        {
            "name": "third party supply chain services pune",
            "description": "Third party supply chain services pune allow businesses to coordinate selected logistics activities through an external transportation and logistics partner. SSK Logistic supports third-party requirements involving freight movement, distribution, warehouse transfers, and supply chain transportation coordination."
        }
    ],

    "tableData": [
        ["supply chain management company pune", "supply chain management services pune"],
        ["supply chain company pune", "supply chain solutions pune"],
        ["supply chain logistics pune", "supply chain service provider pune"],
        ["supply chain management services in pune", "logistics and supply chain company pune"],
        ["supply chain consulting company pune", "end to end supply chain pune"],
        ["supply chain transportation pune", "supply chain distribution services pune"],
        ["supply chain warehouse services pune", "supply chain logistics provider pune"],
        ["supply chain solutions provider pune", "industrial supply chain management pune"],
        ["commercial supply chain services pune", "supply chain operations pune"],
        ["supply chain optimization pune", "supply chain partner pune"],
        ["reliable supply chain company pune", "professional supply chain management pune"],
        ["supply chain transportation services pune", "supply chain distribution company pune"],
        ["third party supply chain services pune", "Supply Chain Management Company in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Coordinated Supply Chain Movement",
            WhyChoosedescription: "SSK Logistic connects transportation, distribution, warehouse transfers, and goods movement into a coordinated logistics process. This approach helps businesses manage different stages of their supply chain without treating each transportation requirement as an isolated activity."
        },
        {
            WhyChooseheading: "Industrial and Commercial Support",
            WhyChoosedescription: "Supply chain requirements can vary considerably between manufacturing units, distributors, wholesalers, and commercial businesses. SSK Logistic structures transportation support around the type of goods, movement frequency, destination network, and operational requirements involved."
        },
        {
            WhyChooseheading: "Route-Based Transportation Planning",
            WhyChoosedescription: "Long-distance and regional supply chains require practical route coordination to maintain predictable movement between different operational points. SSK Logistic assists with route planning for Pune-based businesses connecting with Maharashtra destinations and major markets across India."
        },
        {
            WhyChooseheading: "Warehouse Transfer Assistance",
            WhyChoosedescription: "Movement between warehouses, manufacturing facilities, distribution centers, and commercial locations is an important part of supply chain operations. SSK Logistic provides transportation coordination for such transfers while keeping the broader distribution requirement in consideration."
        },
        {
            WhyChooseheading: "Support for Recurring Shipments",
            WhyChoosedescription: "Businesses with regular dispatch schedules often need transportation support that can accommodate repeated movement rather than occasional shipments alone. SSK Logistic assists with recurring supply chain transportation requirements across established routes and distribution networks."
        },
        {
            WhyChooseheading: "Flexible Logistics Coordination",
            WhyChoosedescription: "Different businesses operate with different shipment volumes, delivery schedules, warehouse locations, and distribution patterns. SSK Logistic offers flexible logistics coordination that can be aligned with changing transportation requirements and multi-location supply chain activities."
        },
        {
            WhyChooseheading: "Pune-Centered Distribution Connectivity",
            WhyChoosedescription: "Pune businesses frequently coordinate goods movement with regional and national markets. SSK Logistic supports this network through transportation and distribution services connecting business locations, suppliers, warehouses, manufacturing facilities, and destination markets."
        },
        {
            WhyChooseheading: "Structured Goods Flow",
            WhyChoosedescription: "A well-coordinated supply chain depends on maintaining an organized flow of goods between each operational stage. SSK Logistic focuses on practical transportation and distribution coordination that helps businesses structure material movement from origin points through storage and onward delivery."
        }
    ]

};



















const faqData = [
    {
        question: "What supply chain management services does SSK Logistic provide in Pune?",
        answer: "SSK Logistic supports businesses with transportation and logistics coordination that can assist supply chain movement from Pune, including the transfer of materials, inventory, equipment, finished products, and commercial consignments."
    },
    {
        question: "Can SSK Logistic manage goods movement between Pune and other cities?",
        answer: "Businesses can coordinate supply chain transportation from Pune to destinations such as Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, and other locations across India."
    },
    {
        question: "What types of materials can be handled through SSK Logistic?",
        answer: "Depending on transportation and handling requirements, suitable materials may include raw materials, industrial supplies, machinery, equipment, finished products, packaged goods, commercial stock, and warehouse inventory."
    },
    {
        question: "Can SSK Logistic support companies with recurring supply chain transportation?",
        answer: "Companies with regular material movement can discuss recurring logistics arrangements based on their supply routes, shipment frequency, inventory requirements, cargo volumes, vehicle capacities, and planned delivery schedules."
    },
    {
        question: "How does SSK Logistic plan transportation for supply chain requirements?",
        answer: "Transportation planning considers the pickup point, destination, cargo type, weight, dimensions, shipment quantity, loading requirements, route distance, vehicle capacity, and expected delivery timeline."
    },
    {
        question: "Can SSK Logistic support Pune to Mumbai supply chain transportation?",
        answer: "Yes, businesses can coordinate movement of commercial stock, raw materials, equipment, finished products, industrial supplies, and other suitable consignments between Pune and Mumbai as part of their transportation requirements."
    },
    {
        question: "Does SSK Logistic provide interstate supply chain transportation from Pune?",
        answer: "Interstate cargo movement can be coordinated toward destinations in Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other parts of India according to the shipment and route requirements."
    },
    {
        question: "Can manufacturers use SSK Logistic for supply chain transportation?",
        answer: "Manufacturers, distributors, suppliers, warehouses, and industrial businesses can use transportation support for moving materials between production units, storage locations, suppliers, distribution points, and other business destinations."
    },
    {
        question: "Can supply chain transportation be customized for different businesses?",
        answer: "Transportation arrangements can be adapted to the company's operational requirements, including pickup schedules, delivery destinations, cargo volumes, vehicle capacities, loading conditions, shipment frequency, and expected timelines."
    },
    {
        question: "What information is needed to discuss supply chain services with SSK Logistic?",
        answer: "Businesses can provide their pickup locations, delivery destinations, material details, approximate quantities, shipment frequency, vehicle requirements, loading information, and preferred delivery schedule to discuss a suitable logistics arrangement."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Yashwant Pawar",
        feedback: "Our company needed support for moving materials between Pune and our distribution location. SSK Logistic understood the recurring shipment requirement and coordinated transportation around our regular business schedule.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Shruti Vaidya",
        feedback: "We used SSK Logistic for transporting finished products from Pune to Hyderabad. The team took the shipment details into account and helped organize the vehicle and route requirements for our supply movement.",
        rating: 5
    }
];













    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Supply Chain Management Company in Pune",
  "image": "https://ssklogistics.in/assets/images/supply-chain-management-company-in-pune.webp",
  "description": "SSK Logistics supports businesses looking for a Supply Chain Management Company in Pune with coordinated logistics, transportation and shipment movement solutions designed around commercial and industrial requirements. Supply chain management company Pune requirements can involve planning the movement of goods from suppliers and manufacturers to warehouses, distributors, retailers and final business destinations. Supply chain management services Pune can include transportation coordination, freight movement, cargo planning, warehouse transfer support, shipment scheduling and route management. As a supply chain company Pune, SSK Logistics assists businesses with practical supply chain logistics Pune solutions for recurring consignments, distribution requirements and interstate transportation. Supply chain solutions Pune can be structured around cargo type, shipment frequency, destination, vehicle requirements and delivery timelines, while a supply chain service provider Pune can help coordinate different stages of commercial goods movement. Supply chain management services in Pune may support manufacturers, wholesalers, distributors, retailers, e-commerce businesses and industrial companies managing regular material flows. Logistics and supply chain company Pune requirements can include freight transportation, warehouse-to-warehouse movement, supplier transportation and business distribution support. Supply chain consulting company Pune requirements may involve transportation planning and logistics coordination based on operational needs. End to end supply chain Pune support can connect procurement-side transportation, warehouse transfers and onward goods movement, while supply chain transportation Pune focuses on reliable movement of products, materials and commercial consignments between important supply chain locations. SSK Logistics provides flexible coordination intended to help businesses organize transportation and logistics activities across Pune, Maharashtra and interstate routes.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Logistics Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/supply-chain-management-company-in-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Supply Chain Management Company in Pune | Logistics, Transportation & Supply Chain Solutions | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics provides supply chain management services in Pune covering logistics coordination, transportation, freight movement, warehouse transfers and end-to-end supply chain solutions."
  />

  <meta
    name="keywords"
    content="Supply Chain Management Company in Pune, supply chain management company Pune, supply chain management services Pune, supply chain company Pune, supply chain solutions Pune, supply chain logistics Pune, supply chain service provider Pune, supply chain management services in Pune, logistics and supply chain company Pune, supply chain consulting company Pune, end to end supply chain Pune, supply chain transportation Pune, supply chain management company in Pune, supply chain services Pune, supply chain logistics services Pune, supply chain transportation services Pune, supply chain solutions in Pune, supply chain provider Pune, supply chain service provider in Pune, logistics supply chain services Pune, commercial supply chain Pune, industrial supply chain Pune, business supply chain management Pune, supply chain planning Pune, supply chain coordination Pune, supply chain distribution Pune, supply chain freight services Pune, supply chain cargo transportation Pune, supply chain goods transportation Pune, warehouse supply chain services Pune, warehouse transportation Pune, supplier transportation Pune, distribution logistics Pune, freight logistics Pune, commercial logistics Pune, industrial logistics Pune, B2B supply chain services Pune, end to end logistics Pune, logistics management Pune, supply chain transportation services Maharashtra"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Supplychainmanagamentcompanyinpune;